import { WhatsNewChangeType } from '@features/whats-new/models/whats-new.model';

export interface HomeTile {
  userHomePageTileId?: string;
  tileType: HomePageTileType;
  name: string;
  isPinned: boolean;
  position: number;
  items: TileItem[][];
}

export interface TileItem {
  // See if this is needed
  id: string;
  itemPrefix: string;
  tileType: number;
  tileSubType?: number;
  subjectMatter: HomePageTileSubjectMatter; // The type of item that this item is about (e.g. comment on synonym, favorite, etc)
  classKeyId?: string;
  itemTitle?: string;
  introduction?: string;
  description: string;
  changeType?: WhatsNewChangeType;
  enabled: boolean;
  createdOn?: Date;
}

export enum HomePageTileType {
  None = 0,
  SearchHistory = 1,
  Favorite = 2,
  Synonym = 3,
  NmfcBook = 4,
  Comment = 5,
  CompanyCommon = 6,
  Default = 100
}

export enum HomePageTileSubType {
  //Favorites
  MostVisited = 0,
  LastVisited = 1,

  //NMFC Book
  NMFCBookSummary = 2,
  RecentlyVisited = 3,
  Bookmarked = 4,

  //Search History
  SearchHistorySummary = 5,
  Recently = 6,
  Yesterday = 7,
  Previous = 8,

  //Company Common
  CompanyCommonSummary = 9,
  SearchHistory = 10,
  Bookmarks = 11,
  Synonyms = 12,
  Favorites = 13
}

export enum HomePageTileSubjectMatter {
  NONE,
  SYNONYM,
  ARTICLE,
  FAVORITE,
  BOOKMARK,
  SEARCH_HISTORY
}
